var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.475 4.36288L6.275 8.57538C6.225 8.62538 6.17083 8.66088 6.1125 8.68188C6.05417 8.70288 5.99167 8.71322 5.925 8.71288C5.85833 8.71288 5.79583 8.70255 5.7375 8.68188C5.67917 8.66122 5.625 8.62572 5.575 8.57538L1.3625 4.36288C1.24583 4.24622 1.1875 4.10038 1.1875 3.92538C1.1875 3.75038 1.25 3.60038 1.375 3.47538C1.5 3.35038 1.64583 3.28788 1.8125 3.28788C1.97917 3.28788 2.125 3.35038 2.25 3.47538L5.925 7.15038L9.6 3.47538C9.71667 3.35872 9.8605 3.30038 10.0315 3.30038C10.2025 3.30038 10.3503 3.36288 10.475 3.48788C10.6 3.61288 10.6625 3.75872 10.6625 3.92538C10.6625 4.09205 10.6 4.23788 10.475 4.36288Z",
    fill: "#ABB3BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.40876acb6fe9a68b6c4780641ac5eaa3.svg";
export { ForwardRef as ReactComponent };